import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, StateToken, Store} from '@ngxs/store';
import {catchError, tap} from 'rxjs/operators';
import {throwError} from "rxjs";
import {GetPosicionAction} from "../actions/dashboard.actions";
import {DashboardApiService} from "../api/dashboard-api.service";
import {Posicion} from "../models/posicion.model";

export interface DashboardStateModel {
  posicion:Posicion
}

const initialState: DashboardStateModel = {
  posicion:null
};

const DASHBOARD_STATE_TOKEN = new StateToken<DashboardStateModel>('dashboard');

@State<DashboardStateModel>({
  name: DASHBOARD_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class DashboardState {

  constructor(
    private store: Store,
    private dashboardApiService:DashboardApiService
  ) {}

  @Action(GetPosicionAction)
  handleGetBankListAction(ctx: StateContext<DashboardStateModel>) {

    ctx.patchState({
      posicion:null
    })

    return this.dashboardApiService.getPosicion().pipe(
      tap(posicion => {
        const state = ctx.getState();

        ctx.patchState({
          posicion
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );

  }

  @Selector()
  static getPosicion(state: DashboardStateModel) {
    return state?.posicion
  }
}
